@import "../../../../styles/_media.css";

.prayerTimesItems {
  display: flex;
  text-align: center;
  align-items: center;
}

.prayerTimesContainer {
  display: flex;
  align-items: flex-end;
  justify-items: end;

  &.isMobile {
    width: 100%;
    max-width: 352px;

    .prayerTimesItems {
      gap: 1px;
    }

    .prayerTimeItem {
      color: #7a7a7a;
    }
  }

  @media (--mobile-only) {
    &.isMobile {
      display: flex;
      align-items: center;
      justify-content: center;

      .prayerTimesLogo,
      .prayerTimeItem {
        font-size: var(--font-xxs);
        font-weight: var(--font-weight-bold);
        padding: 8px;
      }
    }
  }

  @media (--tablet) {
    display: flex;

    &.isMobile {
      display: none;
    }
  }
}

.prayerTimeItem {
  font-size: 11px;
  padding: 0 8px;
  line-height: 1.2;

  &:last-child {
    padding: 0 0 0 8px;
  }
}

.prayerTimeLabel {
  font-weight: var(--font-weight-regular);
}

.prayerTimeValue {
  font-weight: var(--font-weight-semibold);
}
